<!--
 * @Author: tony.zhu
 * @Date: 2025-10-15 17:00:33
 * @LastEditTime: 2025-10-31 14:43:23
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-dialogue">
    <el-scrollbar
      :class="[
        'c-scrollbar',
        isShowContent == CONTENT_MENU.NO_DATA ? 'is-blank' : '',
      ]"
    >
      <div class="content_wrap">
        <template v-if="isShowContent == CONTENT_MENU.HAVE_DATA">
          <div class="dialogue_list_wrap">
            <div
              v-for="(item, index) in formModelData.dialogueList"
              :key="item.id + index"
              :ref="`item_${index}`"
              :data-custom-id="item.id"
              class="dialogue_list_wrap__item"
            >
              <template
                v-if="
                  formModelData.dialogueList[index] &&
                  formModelData.dialogueList[index].question &&
                  formModelData.dialogueList[index].question.type ==
                    qaTypeEnum.Object.QUESTION.code
                "
              >
                <QuestionItem
                  :dataProp="formModelData.dialogueList[index].question"
                  :lengthProp="formModelData.dialogueList.length"
                  v-on="$listeners"
                  :formModalDataProp="item"
                  :index="index"
                  v-bind="$attrs"
                  @open-image-preview="$emit('open-image-preview', $event)"
                ></QuestionItem>
              </template>

              <template
                v-if="
                  formModelData.dialogueList[index] &&
                  formModelData.dialogueList[index].answer &&
                  formModelData.dialogueList[index].answer.type ==
                    qaTypeEnum.Object.ANSWER.code
                "
              >
                <AnswerItem
                  :dataProp="item.answer"
                  v-on="$listeners"
                  :formModalDataProp="item"
                  :index="index"
                >
                  <div
                    v-for="(e, i) in item.answer.content"
                    :key="e.id + i"
                    :slot="e.type + i"
                  ></div>
                </AnswerItem>
              </template>
            </div>
          </div>
        </template>
        <template v-if="isShowContent == CONTENT_MENU.NO_DATA">
          <div class="blank">暂无数据</div>
        </template>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { CONTENT_MENU } from "@/components/aiChat/common/notification.js";
import { changeMappingHandle } from "@/components/aiChat/utils/tbox.js";
import QuestionItem from "@/components/aiChat/components/question/questionItem.vue";
import AnswerItem from "@/components/aiChat/components/answer/answerItem.vue";

export default {
  components: {
    QuestionItem,
    AnswerItem,
  },
  props: {
    formModelDataProp: {
      type: Object,
      default() {
        return { dialogueList: [] };
      },
    },
    historyLoading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isShowContent: -1,
      CONTENT_MENU,
      formModelData: {
        dialogueList: [],
      },
    };
  },
  computed: {
    qaTypeEnum() {
      const mapping = {
        QUESTION: {
          id: 1,
          code: "question",
          label: "问题",
        },
        ANSWER: {
          id: 2,
          code: "answer",
          label: "回答",
        },
      };

      return changeMappingHandle(mapping);
    },
  },
  watch: {
    formModelDataProp: {
      handler: function (n) {
        if (n && Object.keys(n).length) {
          for (const key in n) {
            if (Object.hasOwnProperty.call(n, key)) {
              const e = n[key];
              for (const t in this.formModelData) {
                if (Object.hasOwnProperty.call(this.formModelData, t)) {
                  if (t == key) {
                    this.formModelData[key] = e;
                  }
                }
              }
            }
          }
          if (this.formModelData.dialogueList.length) {
            this.isShowContent = CONTENT_MENU.HAVE_DATA;
          } else if (!this.historyLoading) {
            this.isShowContent = CONTENT_MENU.NO_DATA;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
//@import "styles/index.scss";

.c-dialogue {
  height: 100%;
  padding-bottom: 24px;
  .c-scrollbar {
    // height: calc(100vh - 212px);
    height: 100%;
    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden;
      margin-bottom: 0 !important;
    }
    ::v-deep .el-scrollbar__bar {
      .is-horizontal {
        display: none;
      }
    }

    &.is-blank {
      ::v-deep .el-scrollbar__view {
        height: 100%;
        .content_wrap {
          height: calc(100% - 16px);
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .content_wrap {
    padding-right: 16px;
    padding-bottom: 16px;
    .blank {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: #1d2129;
    }
  }
}
</style>